import {Tooltip} from "antd";
import Icon from "@ant-design/icons";
import React from "react";
import {CopyIcon} from "./CopyIcon";
import styles from "./styles.module.css";

export type CopyProps = {
    tooltip: string
    onCopy: () => void
    className?: string
}

export const Copy = ({tooltip, className, onCopy}: CopyProps) => {
    return <Tooltip
        title={tooltip}
    >
        <span
            className={className}
            onClick={(e) => {
                e.stopPropagation()
                onCopy()
            }}
        >
            <Icon component={CopyIcon} className={styles.action}/>
            &nbsp;
            <span>Copy</span>
        </span>
    </Tooltip>
}